import { Action, Selector, State, StateContext, Store } from "@ngxs/store";
import { Users, UserService, EncounterDraftEmail, TemplateEmail, EmailService, Emails, TemplateEmails, ReceivedEmail} from '@harlowe/core';
import { Injectable } from "@angular/core";
import { append, patch, removeItem, updateItem } from "@ngxs/store/operators";
import { EncounterService } from "../../services/encounter.service";
import { lastValueFrom } from "rxjs";
import { plainToInstance } from "class-transformer";
import { EmailStateModel } from "./email-model";
import { Encounters } from "../encounters/encounter-actions";

@State<EmailStateModel>
(
    {
        name: "email",
        defaults:
        {
            encounter: undefined,
            templateEmails: [],
            encounterDraftEmails: [],
            receivedEmails: [],
            unreadReceivedEmails: [],
            templateEmail: {} as TemplateEmail
        }
    }
)

  @Injectable({ providedIn: 'root' })
  export class EmailState
  {
    constructor(private _store: Store, private _emailService: EmailService, private _encounterService: EncounterService, private _userService: UserService){}

    @Selector()
    static templateEmails(state: EmailStateModel)
    {
        return state.templateEmails.map(e => plainToInstance(TemplateEmail, e));
    }

    @Selector()
    static encounterDraftEmails(state: EmailStateModel)
    {
        return state.encounterDraftEmails.map(e => plainToInstance(EncounterDraftEmail, e));
    }

    @Selector()
    static receivedEmails(state: EmailStateModel)
    {
        return state.receivedEmails;
    }

    @Selector()
    static unreadReceivedEmails(state: EmailStateModel)
    {
        return state.unreadReceivedEmails;
    }

    @Selector()
    static templateEmail(state: EmailStateModel)
    {
        return state.templateEmail;
    }

    @Action(Users.UserLoggedIn)
    async userLoggedIn(ctx: StateContext<EmailStateModel>, action: Users.UserLoggedIn)
    {
    }
    
    @Action([Emails.EmailServiceEncounterEmailDraftAdded])
    emailAdded(ctx: StateContext<EmailStateModel>, action: Emails.EmailServiceEncounterEmailDraftAdded )
    {   
        ctx.setState
        (
            patch<EmailStateModel>
            ({
                encounterDraftEmails: append([action.payload.draftEmail])
            })
        );
    }

    @Action([Emails.EmailServiceEmailDraftUpdated])
    async emailSaved(ctx: StateContext<EmailStateModel>, action: Emails.EmailServiceEmailDraftUpdated)
    {
        

        //See if the draft is in either of our lists
        const state = ctx.getState();

        if(state.encounterDraftEmails.map(e => e.id).includes(action.payload.draftEmail.id))
        {
            var encounterId = state.encounterDraftEmails.find(d => d.id == action.payload.draftEmail.id)?.encounterId;
            var eDraft = await this._encounterService.getEncounterDraftEmail(encounterId!,action.payload.draftEmail.id!);

            ctx.setState
            (
                patch
                (
                    { encounterDraftEmails: updateItem(draft => draft.id === eDraft.id, eDraft) }
                )
            )
        } 

    }

    @Action([Emails.EmailServiceEmailDraftDeleted, Emails.EmailServiceEmailDraftSent], { cancelUncompleted: true })
    async emailDraftRemoved(ctx: StateContext<EmailStateModel>, action: Emails.EmailServiceEmailDraftDeleted | Emails.EmailServiceEmailDraftSent)
    {
        //The draft email is no longer in the lists...
        const state = ctx.getState();

        if(state.encounterDraftEmails.map(e => e.id).includes(action.payload.draftEmailId))
        {
            ctx.setState
            (
                patch<EmailStateModel> ({ encounterDraftEmails: removeItem(draft => draft.id == action.payload.draftEmailId) })
            )
        }
    }

    @Action([TemplateEmails.EmailServiceEmailTemplateDeleted])
    async EmailTemplateRemoved(ctx: StateContext<EmailStateModel>, action: TemplateEmails.EmailServiceEmailTemplateDeleted)
    {
        ctx.setState
        (
            patch<EmailStateModel> ({ templateEmails: removeItem(template => template.id == action.payload.templateEmailId)})
        )
    }

    @Action([TemplateEmails.EmailServiceEmailTemplateSaved])
    async EmailTemplateSaved(ctx: StateContext<EmailStateModel>, action: TemplateEmails.EmailServiceEmailTemplateSaved)
    {
            ctx.setState
            (
                patch<EmailStateModel>
                (
                    { templateEmails: updateItem(templateEmail => templateEmail.id == action.payload.templateEmail.id, action.payload.templateEmail) }
                )
            )
    }

    @Action([TemplateEmails.EmailServiceEmailTemplateAdded])
    async EmailTemplateAdded(ctx: StateContext<EmailStateModel>, action: TemplateEmails.EmailServiceEmailTemplateAdded)
    {
        ctx.setState
        (
            patch<EmailStateModel>
            (
                { templateEmails: append([action.payload.templateEmail]) }
            )
        )
    }




    @Action([Emails.EmailServiceEmailReceivedRead])
    emailReceivedRead(ctx: StateContext<EmailStateModel>, action: Emails.EmailServiceEmailReceivedRead)
    {
        ctx.setState
        (
            patch<EmailStateModel>({
                receivedEmails: updateItem<ReceivedEmail>(e => e.id === action.payload.emailId, (e: ReceivedEmail) => ({ ...e, read: true }))
            })
        )
    }

    @Action([Encounters.EncounterSelected])
    async encounterSelected(ctx: StateContext<EmailStateModel>, action: Encounters.EncounterSelected)
    {
        var drafts = await this._encounterService.getEncounterDraftEmails(action.payload.encounterId)
        const state = ctx.getState();
        ctx.setState
        (
            { 
                ...state,
                encounter: await lastValueFrom(this._encounterService.getEncounter(action.payload.encounterId)),
                templateEmails: await lastValueFrom(this._emailService.getTemplateEmails()),
                encounterDraftEmails: drafts, 
                receivedEmails: await lastValueFrom(this._encounterService.getEncounterReceivedEmails(action.payload.encounterId)),
            }
        )
    }

    @Action([Emails.PersistState])
    async persistState(ctx:StateContext<EmailStateModel>)
    {
        var state = ctx.getState();

        await this._userService.setSetting("emailState", state);
    }

  }
